import { Table } from "react-bootstrap";
import { TableContainer } from "../../@ui/TableContainer";
import { TableColumn, TableDataType } from "../../types/Table/TableColumns";
import { TableAction } from "./TableAction";
import { ShrinkHeader } from "./ShrinkHeader";

import { useEffect, useState } from "react";
import SortableTableHeader from "./TableHeader";
import TableActionButton from "../../@ui/TableActionButton";
import TableData from "./TableData";
import LoadingSpinner from "../Loading/LoadingSpinner";

interface SortableTableProps {
  columns: TableColumn[];
  data: any[];
  actions?: TableAction[];
  height?: string;
  loading?: boolean;
  noDataMessage?: string;
}

const SortableTable = ({
  columns,
  data,
  actions,
  height,
  loading,
  noDataMessage
}: SortableTableProps) => {
  const [sortField, setSortField] = useState<{
    fieldName: string;
    sortOrder: "asc" | "desc";
  }>();

  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  useEffect(() => {
    if (!sortField) return;

    setTableData((prevData) => {
      const sortedData = [...prevData].sort((a, b) => {
        if (sortField.sortOrder === "asc") {
          return a[sortField.fieldName] > b[sortField.fieldName] ? 1 : -1;
        } else {
          return a[sortField.fieldName] < b[sortField.fieldName] ? 1 : -1;
        }
      });

      return sortedData;
    });
  }, [sortField]);

  return (
    <TableContainer height={height}>
      <Table bordered hover striped>
        <thead>
          <tr>
            {columns.map((column, index) => (
              <SortableTableHeader
                key={index}
                column={column}
                sortField={sortField}
                setSortField={setSortField}
              />
            ))}
            {actions &&
              actions
                .filter((x) => x.show)
                .map((_, index) => (
                  <ShrinkHeader
                    key={index}
                    className="text-white bg-primary"
                  ></ShrinkHeader>
                ))}
          </tr>
        </thead>
        <tbody>
          {tableData &&
            !loading &&
            tableData.map((row, index) => (
              <tr key={index}>
                {columns.map((column, index) => (
                  <TableData key={index} row={row} column={column} />
                ))}
                {actions &&
                  actions
                    .filter((x) => x.show)
                    .map((action, index) => (
                      <td key={index} className="py-1 align-middle">
                        <TableActionButton
                          className="button-content"
                          onClick={() => action.onClick(row)}
                        >
                          {action.content}
                        </TableActionButton>
                      </td>
                    ))}
              </tr>
            ))}
            {(!tableData || tableData.length == 0)  && !loading && (
              <tr className="text-center">
                <td colSpan={columns.length + (actions ? actions.length : 0)}>
                  {noDataMessage || "No data found"}
                </td>
              </tr>
            )}
          {loading && (
            <tr>
              <td
                colSpan={columns.length + (actions ? actions.length : 0)}
                className="text-center"
              >
                <LoadingSpinner />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </TableContainer>
  );
};

export default SortableTable;
